import {showLoaderAsync} from '../../helpers/loaders';
import {mainState} from '../../AppMainState';
import {showError, showWarning} from '../../helpers/alerts';
import {UserAuthApi} from '../../swagger';
import {isTestEnv} from '../../helpers/helpers';
import {trackRegister} from '../../helpers/tracking';
import Cookies from 'js-cookie';
import {IMsalContext} from '@azure/msal-react';
import {PublicClientApplication} from '@azure/msal-browser';
import {CredentialResponse} from '@react-oauth/google';

//TODO: Przenieść do backu
export const GOOGLE_LOGIN_CLIENT_ID = isTestEnv() ? '1026079709007-lulau86stsfh7upt7uoi7ga0mmrnf86e.apps.googleusercontent.com' : '403936767572-mkj1at8gn5brv4d2gsdgcmi585udr5bf.apps.googleusercontent.com';

export const msalConfig = {
    auth: {
        clientId: isTestEnv() ? '6c2239fc-b3bb-49de-96ac-53c2d46db979' : '8513dd78-4828-42d2-8692-9c556ae5758d',
        authority: 'https://login.microsoftonline.com/common',
        redirectUri: window.location.origin + '/signin-oidc',
    },
    cache: {
        cacheLocation: 'sessionStorage', // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    }
};

const msalInstance = new PublicClientApplication(msalConfig);

export const loginRequest = {
    scopes: ['email']
};

export class SocialLoginState {
    protected userAuthApi: UserAuthApi = new UserAuthApi();
    protected registration = false;


    signInWithMicrosoft(msal: IMsalContext, register?: boolean) {
        msal.instance.loginPopup(loginRequest)
            .then(res => {
                this.track(register);

                showLoaderAsync(this.userAuthApi.userAuthMicrosoftPost({
                    loginSocialRequest: {
                        tokenId: res.idToken,
                        registrationToken: res.accessToken,
                        acquisitionSource: register ? Cookies.get('utm_source') : undefined,
                        registration: this.registration,
                    },
                })).then(res => {
                    if (res.errors && res.errors.length > 0) {
                        showWarning('Error', res.errors[0]);
                        return;
                    }

                    mainState.loadBaseAppInformation();
                    if (register) {
                        document.location.reload();
                    }

                }).catch((res) => {
                    showError('Error when logging in', 'Please try again later', res);
                });


            })
            .catch(e => {
                console.log(e);
            });
    }

    track(register: boolean | undefined) {
        if (!isTestEnv()) {
            if (register) {
                trackRegister();
            } else {
                // @ts-ignore
                if (typeof window.plausible === 'function') {
                    // @ts-ignore
                    plausible('Login');
                }
            }
        }
    }

    signInWithGoogle(v: CredentialResponse, register?: boolean) {
        const urlParams = new URLSearchParams(window.location.search);

        this.track(register);


        showLoaderAsync(this.userAuthApi.userAuthGooglePost({
            loginSocialRequest: {
                tokenId: v.credential,
                registrationToken: urlParams.get('token'),
                acquisitionSource: register ? Cookies.get('utm_source') : undefined,
                registration: this.registration,
            },
        })).then(res => {
            if (res.errors && res.errors.length > 0) {
                showWarning('Error', res.errors[0]);
                return;
            }

            mainState.loadBaseAppInformation();
            if (register) {
                document.location.reload();
            }

        }).catch((res) => {
            showError('Error when logging in', 'Please try again later', res);
        });
    }

}

